import { useEffect } from "react";

let appName = "Slate";

export function setAppName(name: string): void {
  appName = name;
}

/** `<Scene> · <app name>` — set per scene so browser history and tabs stay readable. The host app sets
 * the name via `setAppName` at mount; it defaults to "Slate" until then. */
export function useDocumentTitle(title?: string): void {
  useEffect(() => {
    document.title = title ? `${title} · ${appName}` : appName;
  }, [title]);
}
